import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6640fcf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Variaveis", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemDeVariavel = _resolveComponent("ItemDeVariavel")!
  const _component_AdicionarVariavel = _resolveComponent("AdicionarVariavel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_TransitionGroup, { name: "variavels" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itensOrdenados, (variavel, indice) => {
          return (_openBlock(), _createBlock(_component_ItemDeVariavel, {
            key: indice,
            variavel: (variavel as VariavelEditavel),
            ehPrimeiro: indice === 0,
            ehUltimo: indice === _ctx.itensOrdenados.length - 1,
            onEditar: _ctx.editar,
            onExcluir: _ctx.excluir,
            onDescer: _ctx.descer,
            onSubir: _ctx.subir
          }, null, 8, ["variavel", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_AdicionarVariavel, {
      indice: _ctx.itensOrdenados.length,
      onAdicionarItem: _ctx.adicionarItem
    }, null, 8, ["indice", "onAdicionarItem"])
  ], 64))
}